import { React, useEffect, useState } from "react";
import { Button, Form, Input, Select, Col, Row, Checkbox, Radio } from "antd";
import warning from "../../../Assets/Icons/warning.png";
import Iconmoon from "../../../Components/IconsFiles/icon";
import {
  HaberForm,
  RightDrawerContainer,
  DownArrowDraw,
  DetailFields,
  DropDownSearchDraw
} from "../../styledElements";
import RightDrawerSidebar from "../../../Components/RightDrawer/rightDrawer";
import { DatePicker } from "antd";
import { DatePickerY } from "../../pageStyled";
import { cancelOrderQuantity, getAllOrdersListByOrderno, getPendingOrderDetailsById, saveSplitOrder, sheetMatchingSplitOrder } from "../../../Services/orderServices";
import moment from "moment";
import { getProductDetails } from "../../../Services/productServices";
import { getCustomerDetails } from "../../../Services/customerServices";
import AlertContainer from "../../../Components/AlertBoxes/alertBox";
import alertGreen from "../../../Assets/Icons/alertGreen.svg";
import alertRed from "../../../Assets/Icons/alertRed.svg";
import { ModalPopup } from "../../../Components/Modal/modal";
import { Collapse } from 'antd';
import { getUnitData } from "../../../Services/measurementService";
import { weightUnit, weight_Unit_Conversions, orderDim_Rewinder_Unit_Conversion, conversionFactorUnitsToTonne, conversionFactorTonneToUnits, CoversionFactorUnitsToCM, lengthUnit } from "../../../Utils/Constant/MeasurementUnitList";
import { toHandlePOName } from "../../../Utils/helper/helper";

const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);
const { Option } = Select;
const { TextArea } = Input;
const { Panel } = Collapse;

const CancelQuantityDrawer = (props) => {
    const [orderDetails, setOrderDetails] = useState();
    const [orderNo, setOrderNo] = useState("");
    const [form] = Form.useForm();
    
    const [actionToaster, setActionToaster] = useState({
        error: "",
        msg: "",
      });
    const [visibleToaster, setVisibleToaster] = useState(false);
    
    const [measurementData, setMeasurementData] = useState();
    const [validationError, setValidationError] = useState(false);



    const validateCancelledQuantity = (e) => {
      if(orderDetails?.type == 'reel' && orderDetails.quantity_type == 'reel_sheet' && (form.getFieldValue('pending_quantity') < form.getFieldValue('cancelled_quantity') ) )
      {
        setValidationError(true);
      }
      else if((form.getFieldValue('pending_quantity')* conversionFactorUnitsToTonne[form.getFieldValue('pending_unit')]) < (form.getFieldValue('cancelled_quantity')* conversionFactorUnitsToTonne[form.getFieldValue('cancelled_unit')]))
      {
      setValidationError(true);
      }
      else
      {
      setValidationError(false);
      }
    };

 

    const handleClose = () => {
      setOrderDetails();
     props.onClose();
    };

    const showToaster = () => {
       
      };

    const onFinish = async (e) => {
      if(!validationError)
      {
        let  req ;

        if(orderDetails?.type == 'reel' && orderDetails.quantity_type == 'reel_sheet')
        {
       req = {
        cancelled_quantity : parseFloat( e.cancelled_quantity),
         
      
      }
    }
    else
    {
       req = {
        cancelled_weight : parseFloat( e.cancelled_quantity),
        units:{
            cancelled_weight: (orderDetails?.type == 'reel' && orderDetails.quantity_type == 'reel_sheet') ? 'reels' : form.getFieldValue('cancelled_unit')
        }  
    
    }
    }

      try {
        const editResponse = await cancelOrderQuantity(req, orderNo);
        if (!editResponse.error) {
          props.toasterAction({
            error: false,
            msg: `Order updated successfully`,
          });
          setOrderDetails();
          props.showToaster();
          props.rendering(true);
          props.onClose();
          
        }
      } catch (error) {
        props.toasterAction({
          error: error.response.data.error,
          msg: error.response.data.msg,
        });
        props.showToaster();
          props.rendering(true);
          props.onClose();
      }
      }

     
    };

    useEffect(() => {
      (async () => {
        getPendingOrderDetailsById(props.selectedOrderNo)
        .then((response) => {
          setOrderDetails(response.data);
          setOrderNo(response.data.id);
        })
        .catch((error) => {
          console.log(error);
        });
        try{
          const unitData = await getUnitData();
          if(!unitData.error){
            setMeasurementData(unitData.data);

          }
        } catch(err){
          console.log(err);
        }
    })();
    },
    []
    );
  
        
    return (
      (orderDetails && measurementData ) ? (
        <RightDrawerSidebar
          title={`Cancel Quantity`}
          subtitle=""
          visible={props.visible}
          onClose={handleClose}
        >
          <RightDrawerContainer>
            <div className="resetPassForm removePadLeft">
            {visibleToaster && (
            <AlertContainer
              setClose={setVisibleToaster}
              color={actionToaster.error ? "red" : "green"}
              icon={actionToaster.error ? alertRed : alertGreen}
              msg={actionToaster.msg}
              closeIcon={true}
            />
          )}
              <DetailFields className="marginBtnP">
                <HaberForm>
                  <Form
                    name="basic"
                    autoComplete="off"
                    className="haberLogin haberSignup"
                    style={{ marginTop: "5px" }}
                    onFinish={onFinish}
                    form={form}
                  >
                    <div className="drawerField">
                      <div className="titleWithText">
                        <h5>Order Details</h5>
                        <p style={{ marginBottom: "0px" }}>
                          Purchase Order :{" "}
                          {toHandlePOName(orderDetails.po)}
                        </p>
                        {" "}
                        <p style={{ marginBottom: "0px" }}>
                          Order Number : {orderDetails?.id}
                        </p>
                         <p style={{ marginBottom: "0px" }}>Size : {orderDetails.type == 'reel' ?  (orderDetails?.width + ' ' + capitalize(lengthUnit[orderDetails?.units?.width].displayName)) : (orderDetails?.width + ' X ' + orderDetails.length + ' ' + (lengthUnit[orderDetails?.units?.width].displayName).toUpperCase()) }</p>
                         <p >Order Quantity : {orderDetails.type == 'reel' && orderDetails.quantity_type == 'reel_sheet' ? (orderDetails.quantity + ' Reels') : (orderDetails.weight + ' ' + capitalize(weightUnit[orderDetails.units.total_pending_quantity_weight].displayName)) }</p>
                      </div>
                    </div>
                    <div className="drawerField removeStar">
                      <div className="titleWithText">
                        <h5>Pending Quantity</h5>
                        <p>Details of the quantity pending to be planned in deckle</p>
                      </div>
                      <Col span={24}>
                        <Row className="centerAlign  justifyCSBetween">
                          <Col span={16} className="blockBreak">
                            <div
                              className="boxFormType"
                              style={{ marginBottom: "0" }}
                            >
                              <Form.Item
                                name="pending_quantity"
                                
                                className="dBlock"
                                initialValue={orderDetails?.type == 'reel' && orderDetails.quantity_type == 'reel_sheet' ? (orderDetails.total_pending_quantity) : (orderDetails.total_pending_quantity_weight) }
                              >
                                <Input
                                  disabled
                                />
                              </Form.Item>
                            </div>
                          </Col>
                        
                         { orderDetails?.type == 'reel' && orderDetails.quantity_type == 'reel_sheet' && <Col span={7} className="blockBreak">
                            <div className="boxFormType unitSelect">
                              <Form.Item
                                name="pending_unit"
                                className="dBlock"
                                initialValue={"Reels"}
                              >
                                <Input disabled/>
                              </Form.Item>
                            </div>
                          </Col>
                          }
                          { ((orderDetails?.type == 'reel' && orderDetails.quantity_type !== 'reel_sheet' ) || orderDetails?.type == 'sheet' ) && <Col span={7} className="blockBreak">
                            <div className="boxFormType unitSelect">
                              <Form.Item
                                name="pending_unit"
                                className="dBlock"
                                initialValue={(orderDetails?.units && orderDetails?.units?.total_pending_quantity_weight)}
                              >
                                <Select
                                  disabled
                                  suffixIcon={<DownArrowDraw />}
                                  className="dBlock"
                                >
                                  {measurementData.units_management.weight.data?.map((deckleWidth) => (
                                    <Option
                                      key={deckleWidth}
                                      value={deckleWidth}
                                    >
                                      {weightUnit[deckleWidth].displayName}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                          }
                        
                        </Row>
                      </Col>
                    </div>
                    <div className="drawerField removeStar">
                      <div className="titleWithText">
                        <h5>Quantity to be Cancelled</h5>
                        <p>Quantity to be cancelled in the order. Cancelled quantity will not be considered for further processing</p>
                      </div>
                      <Col span={24}>
                        <Row className="centerAlign  justifyCSBetween">
                          <Col span={16} className="blockBreak">
                            <div
                              className="boxFormType"
                              style={{ marginBottom: "0" }}
                            >
                              <Form.Item
                                name="cancelled_quantity"
                                
                                className="dBlock"
                               rules={ orderDetails?.type == 'reel' && orderDetails.quantity_type == 'reel_sheet' ?  [ {
                                  required: true,
                                  message: "This field is required",
                                },
                                {
                                  pattern: /^(0*[1-9][0-9]*)$/,
                                  message: "Invalid value",
                                },
                              ] :
                              [ {
                                required: true,
                                message: "This field is required",
                              }
                            ]}
                              >
                                <Input onChange={validateCancelledQuantity}
                                />
                              </Form.Item>
                            </div>
                          </Col>
                          
                         { orderDetails?.type == 'reel' && orderDetails.quantity_type == 'reel_sheet' && <Col span={7} className="blockBreak">
                            <div className="boxFormType unitSelect">
                              <Form.Item
                                name="cancelled_unit"
                                className="dBlock"
                                initialValue={"Reels"}
                              >
                                <Input disabled />
                              </Form.Item>
                            </div>
                          </Col>
                          }
                          { ((orderDetails?.type == 'reel' && orderDetails.quantity_type !== 'reel_sheet') || orderDetails?.type == 'sheet' ) && <Col span={7} className="blockBreak">
                            <div className="boxFormType unitSelect">
                              <Form.Item
                                name="cancelled_unit"
                                className="dBlock"
                                initialValue={(orderDetails?.units && orderDetails?.units?.total_pending_quantity_weight)}
                              >
                                <Select
                                  suffixIcon={<DownArrowDraw />}
                                  className="dBlock"
                                  onChange={validateCancelledQuantity}
                                >
                                  {measurementData.units_management.weight.data?.map((deckleWidth) => (
                                    <Option
                                      key={deckleWidth}
                                      value={deckleWidth}
                                    >
                                      {weightUnit[deckleWidth].displayName}
                                    </Option>
                                  ))}
                                </Select>
                              </Form.Item>
                            </div>
                          </Col>
                          }
                        {validationError && (
                              <span
                                className="errorText"
                                style={{ color: "#ea4e2c", marginTop:"-13px" }}
                              >
                                Quantity to be cancelled cannot be more than pending quantity
                              </span>
                            ) }
                        </Row>
                      </Col>
                    </div>
                    <div className="buttonFlex fixedBtm">
                  <Form.Item>
                    <Button
                      htmlType="submit"
                      className="themeBtn"
                    >
                      <Iconmoon icon="addcircle" size={16} color="#ffffff" />{" "}
                      Save Changes{" "}
                    </Button>
                  </Form.Item>
                  <Form.Item>
                  <Form.Item>
                        <Button
                          key="3"
                          className="textTypeBtn"
                          onClick={handleClose}
                        >
                          Cancel changes
                        </Button>
                      </Form.Item>
                  </Form.Item>
                </div>
                  </Form>
                </HaberForm>
              </DetailFields>
            </div>
          </RightDrawerContainer>

        </RightDrawerSidebar>
      ) : null
    ) ;
};
export default CancelQuantityDrawer;